<script>
	import { onMount } from 'svelte'
	import { fade } from 'svelte/transition'
	import lozad from 'lozad'
	//import locations data
	// export let locations = []
	let dealers = dealersData
	//export let dealersData = []
	//console.log('locations:', locations)
	//Define map node element
	let mapEl
	//Define map on load
	let map
	//Define map icon
	const icon = L.icon({
		iconUrl: '/wp-content/uploads/2021/04/placeholder.png',
		iconSize: [43, 43],
		iconAnchor: [22, 54],
		popupAnchor: [0, -59],
	})
	//Define marker on load
	let markers = new L.markerClusterGroup({ maxZoom: 15 });
	//let marker = new L.marker()
	//Define empty allCoords array
	let allCoords = []
	// lazyload lozad observer
	let observer = lozad('.pgi-image')
	//Reformat location coordinates into array
	dealers = dealers.map(dealer => {
		// required/exists
		let { coordinates } = dealer
		
		// split coords into array
		coordinates = coordinates.split(/\s*,\s*/)
		// Populate allCoords array
		allCoords.push(coordinates)
		//Return object to locations with updated coordinates
		return Object.assign(dealer, {
			coordinates,
		})
	})
	//console.log(dealers)

	onMount(() => {
		//onMount runs on page load
		//!
		//if dealers do not exist, return (do not continue running function)
		if (!dealers.length) {
			return
		}
		//Define Mapbox Access Token
		L.mapbox.accessToken =
			'pk.eyJ1IjoianRnYm9vc3QiLCJhIjoiY2tteHNjendjMDllYjJvbzg0MXNpNXZuYyJ9.JM5hUZABSzxM4F_fNDzFaA'
		//Create map element and bind it to map node
		map = L.mapbox
			.map(mapEl)
			.addLayer(
				L.mapbox.styleLayer(
					'mapbox://styles/jtgboost/ckmxu864v15ad17mf445nsrm2'
				)
				// L.tileLayer(
				// 	"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
				// 	{
				// 	attribution:
				// 		'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
				// 	maxZoom: 18,
				// 	id: "mapbox/outdoors-v10",
				// 	//style: 'mapbox://styles/mapbox/streets-v11',
				// 	accessToken:
				// 		"pk.eyJ1IjoianRnYm9vc3QiLCJhIjoiY2tteHNjendjMDllYjJvbzg0MXNpNXZuYyJ9.JM5hUZABSzxM4F_fNDzFaA", //! ?
				// 	}
				// )
			)
		map.addLayer(markers);
		
		dealers.forEach(dealer => {
			//loop through each location and create markers with coordinates
			let marker = new L.marker(dealer.coordinates, { icon })
			let markerHTML = dealer.img 
				? `<div class="pgi-image" style="background-image:url(${dealer.img})"></div>`
				:'';
			markerHTML += `<div class="pgi-content"><h3>${dealer.name}</h3>`
			//address
			markerHTML += `<p><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M256,0C161.896,0,85.333,76.563,85.333,170.667c0,28.25,7.063,56.26,20.49,81.104L246.667,506.5 c1.875,3.396,5.448,5.5,9.333,5.5s7.458-2.104,9.333-5.5l140.896-254.813c13.375-24.76,20.438-52.771,20.438-81.021 C426.667,76.563,350.104,0,256,0z M256,256c-47.052,0-85.333-38.281-85.333-85.333c0-47.052,38.281-85.333,85.333-85.333 s85.333,38.281,85.333,85.333C341.333,217.719,303.052,256,256,256z"/></g></svg>`
			if (dealer.unit)
				markerHTML += `${dealer.location.street_number} ${dealer.location.street_name }, Unit ${dealer.unit}<br>${dealer.location.city}, ${dealer.location.state_short}`;
			else
				markerHTML += `${dealer.location.street_number} ${dealer.location.street_name }<br>${dealer.location.city}, ${dealer.location.state_short}`;
			
			if (dealer.website) {
				markerHTML += `<p><svg enable-background="new 0 0 512.418 512.418" height="512" viewBox="0 0 512.418 512.418" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m437.335 75.082c-100.1-100.102-262.136-100.118-362.252 0-100.103 100.102-100.118 262.136 0 362.253 100.1 100.102 262.136 100.117 362.252 0 100.103-100.102 100.117-262.136 0-362.253zm-10.706 325.739c-11.968-10.702-24.77-20.173-38.264-28.335 8.919-30.809 14.203-64.712 15.452-99.954h75.309c-3.405 47.503-21.657 92.064-52.497 128.289zm-393.338-128.289h75.309c1.249 35.242 6.533 69.145 15.452 99.954-13.494 8.162-26.296 17.633-38.264 28.335-30.84-36.225-49.091-80.786-52.497-128.289zm52.498-160.936c11.968 10.702 24.77 20.173 38.264 28.335-8.919 30.809-14.203 64.712-15.452 99.954h-75.31c3.406-47.502 21.657-92.063 52.498-128.289zm154.097 31.709c-26.622-1.904-52.291-8.461-76.088-19.278 13.84-35.639 39.354-78.384 76.088-88.977zm0 32.708v63.873h-98.625c1.13-29.812 5.354-58.439 12.379-84.632 27.043 11.822 56.127 18.882 86.246 20.759zm0 96.519v63.873c-30.119 1.877-59.203 8.937-86.246 20.759-7.025-26.193-11.249-54.82-12.379-84.632zm0 96.581v108.254c-36.732-10.593-62.246-53.333-76.088-88.976 23.797-10.817 49.466-17.374 76.088-19.278zm32.646 0c26.622 1.904 52.291 8.461 76.088 19.278-13.841 35.64-39.354 78.383-76.088 88.976zm0-32.708v-63.873h98.625c-1.13 29.812-5.354 58.439-12.379 84.632-27.043-11.822-56.127-18.882-86.246-20.759zm0-96.519v-63.873c30.119-1.877 59.203-8.937 86.246-20.759 7.025 26.193 11.249 54.82 12.379 84.632zm0-96.581v-108.254c36.734 10.593 62.248 53.338 76.088 88.977-23.797 10.816-49.466 17.373-76.088 19.277zm73.32-91.957c20.895 9.15 40.389 21.557 57.864 36.951-8.318 7.334-17.095 13.984-26.26 19.931-8.139-20.152-18.536-39.736-31.604-56.882zm-210.891 56.882c-9.165-5.947-17.941-12.597-26.26-19.931 17.475-15.394 36.969-27.801 57.864-36.951-13.068 17.148-23.465 36.732-31.604 56.882zm.001 295.958c8.138 20.151 18.537 39.736 31.604 56.882-20.895-9.15-40.389-21.557-57.864-36.951 8.318-7.334 17.095-13.984 26.26-19.931zm242.494 0c9.165 5.947 17.942 12.597 26.26 19.93-17.475 15.394-36.969 27.801-57.864 36.951 13.067-17.144 23.465-36.729 31.604-56.881zm26.362-164.302c-1.249-35.242-6.533-69.146-15.452-99.954 13.494-8.162 26.295-17.633 38.264-28.335 30.84 36.225 49.091 80.786 52.497 128.289z"/></svg>`
				markerHTML += `<a target='_blank' href="${dealer.website}" data-type="tel" data-id="tel:${dealer.phone}">${dealer.website}</a></p>`
			}
			if (dealer.phone) {
				markerHTML += `<p><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" xml:space="preserve"><g><g><path d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594 c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448 c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813 C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z" /></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>`
				markerHTML += `<a href="tel:${dealer.phone}" data-type="tel" data-id="tel:${dealer.phone}">${dealer.phone}</a></p>`
			}
			if (dealer.email) {
				markerHTML += `<p><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><polygon points="339.392,258.624 512,367.744 512,144.896 		"/></g></g><g><g><polygon points="0,144.896 0,367.744 172.608,258.624 		"/></g></g><g><g><path d="M480,80H32C16.032,80,3.36,91.904,0.96,107.232L256,275.264l255.04-168.032C508.64,91.904,495.968,80,480,80z"/></g></g><g><g><path d="M310.08,277.952l-45.28,29.824c-2.688,1.76-5.728,2.624-8.8,2.624c-3.072,0-6.112-0.864-8.8-2.624l-45.28-29.856 L1.024,404.992C3.488,420.192,16.096,432,32,432h448c15.904,0,28.512-11.808,30.976-27.008L310.08,277.952z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>`
				markerHTML += `<a href="mailto:${dealer.email}">${dealer.email}</span></p>`
			}
			markerHTML += `</div>`//<a href="#"><span class="sr-only">View</span></a>`
			marker.bindPopup(markerHTML)
			marker.addTo(markers);
			//map.addLayer(marker)
		})

		map.scrollWheelZoom.disable()
		// fit map to markers
		map.fitBounds(allCoords, { maxZoom: 12 })
		//set position of zoom control
		map.zoomControl.setPosition('topright')
	})
</script>

<div class="locations-map section-full" id="map" bind:this={mapEl} data-slideout-ignore />
